import { InterfaceLanguage } from "@/enums";
import { IMainInfoData } from "@/types/apiResponse.types";

export const displayFullName = ({
  selectedLang,
  mainInfo,
}: {
  selectedLang: InterfaceLanguage;
  mainInfo: IMainInfoData;
}) =>
  selectedLang === InterfaceLanguage.KA
    ? `${mainInfo?.firstName || ""} ${mainInfo?.lastName || ""}`
    : `${mainInfo?.firstNameLatin || ""} ${mainInfo?.lastNameLatin || ""}`;
